import { updateColorWithOpacity, AnnotationStatus } from '../../index';
import { Browser, isBlazor, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * RedactionAnnotation class to handle redaction annotations
 *
 * @hidden
 */
var Redaction = /** @class */ (function () {
    /**
     * Constructor for RedactionAnnotation class
     * @param {PdfViewer} pdfviewer - The PDF Viewer instance
     * @param {PdfViewerBase} pdfViewerBase - The PDF Viewer Base instance
     */
    function Redaction(pdfviewer, pdfViewerBase) {
        /**
         * @private
         */
        this.redactionPageNumbers = [];
        /**
         * @private
         */
        this.redactionCount = 0;
        /**
         * @private
         */
        this.isAddAnnotationProgramatically = false;
        /**
         * @private
         */
        this.isRepeat = false;
        /**
         * @private
         */
        this.overlayText = '';
        /**
         * @private
         */
        this.isRedactionHovered = false;
        this.previousTool = '';
        this.isAnnotationHoverd = false;
        this.hoveredRedactionAnnotName = '';
        /**
         * @private
         */
        this.hoveredRedactionId = '';
        this.pdfViewer = pdfviewer;
        this.pdfViewerBase = pdfViewerBase;
        this.initializeRedactionProperties();
    }
    /**
     * Update annotation details for programmatic addition
     * @param {RedactionSettingsModel} options - The redaction settings
     * @param {IPoint} offset - The offset point
     * @returns {any} The redaction annotation object
     * @private
     */
    Redaction.prototype.updateAddAnnotationDetails = function (options, offset) {
        if (!options) {
            offset = options.bound || { x: 10, y: 10 };
        }
        else {
            offset.x = options.bound && !isNullOrUndefined(options.bound.x) ? options.bound.x : 10;
            offset.y = options.bound && !isNullOrUndefined(options.bound.y) ? options.bound.y : 10;
        }
        // Initialize the annotation settings
        var annotationSelectorSettings = options.annotationSelectorSettings ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.annotationSelectorSettings) ||
            this.pdfViewer.annotationSelectorSettings;
        var annotationSettings = this.pdfViewer.annotationModule.updateSettings(this.pdfViewer.redactionSettings);
        var allowedInteractions = options.allowedInteractions ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.allowedInteractions) ||
            this.pdfViewer.annotationSettings.allowedInteractions;
        // Creating the CurrentDate and Annotation name
        var currentDateString = this.pdfViewer.annotation.stickyNotesAnnotationModule.getDateAndTime();
        var annotationName = 'redaction_' + this.pdfViewer.annotation.createGUID();
        // Get properties from options or default values
        var pageNumber = options.pageNumber !== undefined ? options.pageNumber : 0;
        var author = options.author ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.author) ||
            this.pdfViewer.annotationSettings.author ||
            'Guest';
        var markerFillColor = this.pdfViewer.annotationModule.hexToRgba(options.markerFillColor ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.markerFillColor) ||
            'rgba(255, 255, 255, 1)');
        var fillColor = this.pdfViewer.annotationModule.hexToRgba(options.fillColor ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.fillColor) ||
            'rgba(0, 0, 0, 0)');
        var markerBorderColor = this.pdfViewer.annotationModule.
            hexToRgba(options.markerBorderColor ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.markerBorderColor) ||
            'rgba(255, 0, 0, 1)');
        var markerOpacity = options.markerOpacity ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.markerOpacity) ||
            1;
        var isPrint = !isNullOrUndefined(options.isPrint) ?
            !!options.isPrint :
            (this.pdfViewer.redactionSettings && !isNullOrUndefined(this.pdfViewer.redactionSettings.isPrint)) ?
                !!this.pdfViewer.redactionSettings.isPrint :
                true;
        var isLock = !isNullOrUndefined(options.isLock) ?
            !!options.isLock :
            (this.pdfViewer.redactionSettings && !isNullOrUndefined(this.pdfViewer.redactionSettings.isLock)) ?
                !!this.pdfViewer.redactionSettings.isLock :
                false;
        var overlayText = options.overlayText ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.overlayText) ||
            '';
        var fontColor = this.pdfViewer.annotationModule.hexToRgba(options.fontColor ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.fontColor) ||
            'rgba(255, 0, 0, 1)');
        var fontSize = !isNullOrUndefined(options.fontSize) ?
            options.fontSize || 10 :
            (this.pdfViewer.redactionSettings && !isNullOrUndefined(this.pdfViewer.redactionSettings.fontSize)) ?
                this.pdfViewer.redactionSettings.fontSize || 10 :
                10;
        var fontFamily = options.fontFamily ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.fontFamily) ||
            'Helvetica';
        var textAlign = options.textAlignment ||
            (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.textAlignment) ||
            'center';
        // Set width and height
        var width = options.bound ? options.bound.width : 100;
        var height = options.bound ? options.bound.height : 50;
        // Update annotation settings
        annotationSettings.isLock = isLock;
        annotationSettings.minHeight = options.minHeight || 0;
        annotationSettings.minWidth = options.minWidth || 0;
        annotationSettings.maxWidth = options.maxWidth || 0;
        annotationSettings.maxHeight = options.maxHeight || 0;
        // Creating Redaction Annotation object with its proper properties
        var redactionAnnotation = [];
        var redaction = {
            Id: ('redaction' + this.redactionCount++) || 'redaction_' + this.pdfViewer.annotation.createGUID(),
            AllowedInteractions: options.allowedInteractions || allowedInteractions,
            AnnotName: annotationName,
            AnnotType: 'redaction',
            AnnotationSelectorSettings: annotationSelectorSettings,
            AnnotationSettings: annotationSettings,
            Author: author,
            Bounds: {
                X: offset.x,
                Y: offset.y,
                Width: width,
                Height: height,
                Left: offset.x, Top: offset.y,
                Location: { X: offset.x, Y: offset.y },
                Size: { Height: height, IsEmpty: false, Width: width }
            },
            Comments: [],
            CustomData: options.customData || null,
            CreatedDate: currentDateString,
            ExistingCustomData: null,
            FillColor: fillColor,
            FontColor: fontColor,
            FontSize: fontSize,
            FontFamily: fontFamily,
            IsCommentLock: false,
            IsLocked: isLock,
            IsPrint: isPrint,
            MarkerFillColor: markerFillColor,
            MarkerBorderColor: markerBorderColor,
            MarkerOpacity: markerOpacity,
            ModifiedDate: currentDateString,
            Note: '',
            OverlayText: overlayText,
            IsRepeat: options.isRepeat || false,
            RotateAngle: 'RotateAngle0',
            ShapeAnnotationType: 'Redaction',
            State: '',
            StateModel: 'Review',
            Status: AnnotationStatus.NewlyAdded,
            Subject: 'Redaction',
            TextAlign: textAlign
        };
        // Adding the annotation object to an array
        redactionAnnotation[0] = redaction;
        // Create the annotation collection for the page if it doesn't exist
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_redaction');
        var annotObject = [];
        if (storeObject) {
            annotObject = JSON.parse(JSON.stringify(storeObject));
        }
        // Create annotation object for storage
        var annotationObject = {
            shapeAnnotationType: 'Redaction',
            author: author,
            modifiedDate: currentDateString,
            subject: 'Redaction',
            note: '',
            bounds: {
                left: offset.x,
                top: offset.y,
                width: width,
                height: height,
                right: offset.x + width,
                bottom: offset.y + height
            },
            rotateAngle: '0',
            isLocked: isLock,
            annotName: annotationName,
            pageNumber: pageNumber,
            annotationId: annotationName,
            annotationSelectorSettings: annotationSelectorSettings,
            customData: options.customData || {},
            overlayText: overlayText,
            isRepeat: options.isRepeat || false,
            fontColor: fontColor,
            fillColor: fillColor,
            fontSize: fontSize,
            fontFamily: fontFamily,
            textAlign: textAlign,
            markerFillColor: markerFillColor,
            markerBorderColor: markerBorderColor,
            markerOpacity: markerOpacity,
            isPrint: isPrint,
            id: redactionAnnotation[0].Id,
            comments: [],
            review: {},
            isCommentLock: false,
            isReadonly: false,
            annotationSettings: annotationSettings,
            allowedInteractions: allowedInteractions,
            status: AnnotationStatus.NewlyAdded
        };
        var index = this.pdfViewer.annotation.getPageCollection(annotObject, pageNumber);
        if (index === -1 || !annotObject[index]) {
            var pageAnnotations = {
                pageIndex: pageNumber,
                annotations: [annotationObject]
            };
            annotObject.push(pageAnnotations);
        }
        else {
            annotObject[index].annotations.push(annotationObject);
        }
        redactionAnnotation[0].Id = annotationObject.id;
        // Return the annotation in the correct format for the pdfAnnotation object
        return { redactionAnnotation: redactionAnnotation };
    };
    /**
     * Handle redaction annotation hover
     * @param {PdfAnnotationBaseModel} annotation - The annotation being hovered
     * @param {number} pageIndex - The page index
     * @param {any} currentAnnot - currentAnnot
     * @returns {void}
     * @private
     */
    Redaction.prototype.handleRedactionHover = function (annotation, pageIndex, currentAnnot) {
        var currentAnnotationId = annotation.id || '';
        this.previousTool = this.pdfViewer.tool;
        this.hoveredRedactionAnnotName = annotation.annotName;
        var selectedAnnotationIsRedaction = false;
        if (this.pdfViewer.selectedItems.annotations && this.pdfViewer.selectedItems.annotations.length > 0 && this.pdfViewer.selectedItems.annotations[0].id === 'diagram_helper') {
            selectedAnnotationIsRedaction = true;
        }
        if (currentAnnotationId !== 'diagram_helper' && this.hoveredRedactionId !== 'diagram_helper' && !selectedAnnotationIsRedaction) {
            // If hovering over a different annotation than before, reset the previous one
            if (this.isRedactionHovered && this.hoveredRedactionId !== currentAnnotationId) {
                this.resetRedactionHover();
            }
            // Apply hover effect to the current annotation
            if (!this.isRedactionHovered || this.hoveredRedactionId !== currentAnnotationId) {
                // Store the original fill color
                annotation.originalFillColor = annotation.markerFillColor || '';
                // Change the fill color to yellow on hover
                if (annotation.wrapper && annotation.wrapper.children && annotation.wrapper.children.length > 0 && annotation.fillColor) {
                    var fillColor = updateColorWithOpacity(annotation.fillColor, 1);
                    annotation.wrapper.children[0].style.fill = fillColor;
                    annotation.wrapper.children[0].style.strokeColor = fillColor;
                    annotation.wrapper.children[0].style.opacity = 1;
                }
                if (annotation.annotationAddMode === 'TextRedaction') {
                    this.orginalFillColor = annotation.markerFillColor;
                    this.orginalBorderColor = annotation.markerBorderColor;
                    this.orginalOpacity = annotation.markerOpacity;
                }
                // Render overlay text if it exists
                if (annotation.overlayText) {
                    this.pdfViewer.annotation.redactionOverlayTextModule.renderRedactionOverlayText(annotation, currentAnnot);
                }
                this.isAnnotationHoverd = true;
                // Re-render the annotation with the new color
                var canvasElement = document.getElementById(this.pdfViewer.element.id + '_annotationCanvas_' + pageIndex);
                if (canvasElement) {
                    this.pdfViewer.renderDrawing(canvasElement, pageIndex);
                }
                this.isAnnotationHoverd = false;
                // Set flag to prevent re-rendering on every mouse move
                this.isRedactionHovered = true;
                this.hoveredRedactionId = currentAnnotationId;
            }
        }
    };
    /**
     * Reset redaction annotation hover state
     * @returns {void}
     * @private
     */
    Redaction.prototype.resetRedactionHover = function () {
        if (this.isRedactionHovered) {
            this.pdfViewer.tool = this.previousTool;
            this.previousTool = '';
            this.isAnnotationHoverd = false;
            // Check in selectedItems.annotations
            if (this.pdfViewer.selectedItems && this.pdfViewer.selectedItems.annotations) {
                for (var i = 0; i < this.pdfViewer.selectedItems.annotations.length; i++) {
                    var annotation = this.pdfViewer.selectedItems.annotations[i];
                    if (annotation && annotation.shapeAnnotationType === 'Redaction') {
                        // Remove overlay text
                        if (annotation.overlayText) {
                            this.pdfViewer.annotation.redactionOverlayTextModule.removeRedactionOverlayText(annotation);
                        }
                        // Reset fill color
                        if (annotation.originalFillColor) {
                            if (annotation.wrapper && annotation.wrapper.children && annotation.wrapper.children.length > 0) {
                                var opacity = annotation.markerOpacity > 1 ? annotation.markerOpacity / 100 :
                                    annotation.markerOpacity;
                                var fillColor = updateColorWithOpacity(annotation.originalFillColor, annotation.markerOpacity);
                                annotation.wrapper.children[0].style.fill = fillColor;
                                annotation.wrapper.children[0].style.strokeColor = annotation.markerBorderColor;
                                annotation.wrapper.children[0].style.opacity = opacity;
                            }
                            delete annotation.originalFillColor;
                        }
                        // Re-render the annotation with the original color
                        var canvasElement = document.getElementById(this.pdfViewer.element.id + '_annotationCanvas_' + annotation.pageIndex);
                        if (canvasElement) {
                            this.pdfViewer.renderDrawing(canvasElement, annotation.pageIndex);
                        }
                    }
                }
            }
            // Also check in nameTable
            if (this.pdfViewer.nameTable) {
                // If we have a specific hovered redaction ID, only reset that one
                if (this.hoveredRedactionId && this.pdfViewer.nameTable[this.hoveredRedactionId]) {
                    var annotation = this.pdfViewer.nameTable[this.hoveredRedactionId];
                    if (annotation && annotation.shapeAnnotationType === 'Redaction') {
                        // Remove overlay text
                        if (annotation.overlayText) {
                            this.pdfViewer.annotation.redactionOverlayTextModule.removeRedactionOverlayText(annotation);
                        }
                        // Reset fill color
                        if (annotation.originalFillColor) {
                            if (annotation.wrapper && annotation.wrapper.children && annotation.wrapper.children.length > 0) {
                                var opacity = annotation.markerOpacity > 1 ? annotation.markerOpacity / 100 :
                                    annotation.markerOpacity;
                                var fillColor = updateColorWithOpacity(annotation.originalFillColor, annotation.markerOpacity);
                                annotation.wrapper.children[0].style.fill = fillColor;
                                annotation.wrapper.children[0].style.strokeColor = annotation.markerBorderColor;
                                annotation.wrapper.children[0].style.opacity = opacity;
                            }
                            delete annotation.originalFillColor;
                        }
                        // Re-render the annotation with the original color
                        var canvasElement = document.getElementById(this.pdfViewer.element.id + '_annotationCanvas_' + annotation.pageIndex);
                        if (canvasElement) {
                            this.pdfViewer.renderDrawing(canvasElement, annotation.pageIndex);
                        }
                    }
                }
                else {
                    // Otherwise check all annotations in the nameTable
                    for (var key in this.pdfViewer.nameTable) {
                        if (Object.prototype.hasOwnProperty.call(this.pdfViewer.nameTable, key)) {
                            var annotation = this.pdfViewer.nameTable[key];
                            if (annotation && annotation.shapeAnnotationType === 'Redaction') {
                                // Remove overlay text
                                if (annotation.overlayText) {
                                    this.pdfViewer.annotation.redactionOverlayTextModule.removeRedactionOverlayText(annotation);
                                }
                                // Reset fill color
                                if (annotation.originalFillColor) {
                                    if (annotation.wrapper && annotation.wrapper.children && annotation.wrapper.children.length > 0) {
                                        var opacity = annotation.markerOpacity > 1 ? annotation.markerOpacity / 100 :
                                            annotation.markerOpacity;
                                        var fillColor = updateColorWithOpacity(annotation.originalFillColor, annotation.markerOpacity);
                                        annotation.wrapper.children[0].style.fill = fillColor;
                                        annotation.wrapper.children[0].style.strokeColor = annotation.markerBorderColor;
                                        annotation.wrapper.children[0].style.opacity = opacity;
                                    }
                                    delete annotation.originalFillColor;
                                }
                                // Re-render the annotation with the original color
                                var canvasElement = document.getElementById(this.pdfViewer.element.id + '_annotationCanvas_' + annotation.pageIndex);
                                if (canvasElement) {
                                    this.pdfViewer.renderDrawing(canvasElement, annotation.pageIndex);
                                }
                            }
                        }
                    }
                }
            }
            // Reset the hover state
            this.isRedactionHovered = false;
            this.hoveredRedactionId = '';
        }
    };
    /**
     * Initialize redaction properties with default values or from settings
     * @returns {void}
     * @private
     */
    Redaction.prototype.initializeRedactionProperties = function () {
        if (this.pdfViewer.redactionSettings) {
            this.redactionFillColor = this.pdfViewer.redactionSettings.markerFillColor || 'rgba(0, 0, 0, 1)';
            this.redactionMarkerFillColor = this.pdfViewer.redactionSettings.markerFillColor || 'rgba(255, 255, 255, 1)';
            this.redactionBorderColor = this.pdfViewer.redactionSettings.markerBorderColor || 'rgba(255, 0, 0, 1)';
            this.redactionOutlineOpacity = this.pdfViewer.redactionSettings.markerOpacity || 1;
        }
        else {
            this.redactionFillColor = 'rgba(0, 0, 0, 1)';
            this.redactionMarkerFillColor = 'rgba(255, 255, 255, 1)';
            this.redactionBorderColor = 'rgba(255, 0, 0, 1)';
            this.redactionOutlineOpacity = 1;
        }
        this.redactionPageNumbers = [];
    };
    /**
     * Render redaction annotations on the page
     * @param {any} redactionAnnotations - The redaction annotations to render
     * @param {number} pageNumber - The page number to render on
     * @param {boolean} isImportAction - Whether this is an import action
     * @param {any} isAnnotOrderAction - Whether this is an isAnnotOrderAction
     * @returns {void}
     * @private
     */
    Redaction.prototype.renderRedactionAnnotations = function (redactionAnnotations, pageNumber, isImportAction, isAnnotOrderAction) {
        var isAdded = false;
        if (!isImportAction) {
            for (var p = 0; p < this.redactionPageNumbers.length; p++) {
                if (this.redactionPageNumbers[parseInt(p.toString(), 10)] === pageNumber) {
                    var pageAnnotations = this.getAnnotations(pageNumber, null);
                    // Check if annotation already exists
                    if (pageAnnotations !== null && redactionAnnotations) {
                        for (var k = 0; k < pageAnnotations.length; k++) {
                            for (var l = 0; l < pageAnnotations.length; l++) {
                                var redactAnnot = redactionAnnotations[l] ? redactionAnnotations[l] :
                                    redactionAnnotations;
                                var annotationName = redactAnnot.annotName ?
                                    redactAnnot.annotName : redactAnnot.AnnotName;
                                var pageAnnotationName = pageAnnotations[k].annotName ?
                                    pageAnnotations[k].annotName : pageAnnotations[k].AnnotName;
                                if (pageAnnotationName && annotationName && pageAnnotationName === annotationName) {
                                    isAdded = true;
                                    break;
                                }
                            }
                            if (isAdded) {
                                break;
                            }
                        }
                    }
                    break;
                }
            }
        }
        if (redactionAnnotations && (!isAdded || isAnnotOrderAction)) {
            if (redactionAnnotations.length > 0) {
                this.redactionPageNumbers.push(pageNumber);
                for (var i = 0; i < redactionAnnotations.length; i++) {
                    var annotation = redactionAnnotations[i];
                    annotation.annotationAddMode =
                        this.pdfViewer.annotationModule.findAnnotationMode(annotation, pageNumber, annotation.AnnotType);
                    var annotationObject = {};
                    var position = annotation.Bound ? annotation.Bound : annotation.Bounds;
                    var author = annotation.Author || '';
                    annotation.AnnotationSettings = annotation.AnnotationSettings ?
                        annotation.AnnotationSettings : this.pdfViewer.annotationModule.updateAnnotationSettings(annotation);
                    if (isImportAction) {
                        annotation.AnnotationSettings = { minHeight: 0, minWidth: 0,
                            // eslint-disable-next-line security/detect-object-injection
                            maxHeight: this.pdfViewerBase.pageSize[pageNumber].height,
                            // eslint-disable-next-line security/detect-object-injection
                            maxWidth: this.pdfViewerBase.pageSize[pageNumber].width,
                            isPrint: true, isLock: false
                        };
                    }
                    annotation.allowedInteractions = annotation.AllowedInteractions ?
                        annotation.AllowedInteractions :
                        this.pdfViewer.annotationModule.updateAnnotationAllowedInteractions(annotation);
                    var isPrint = true;
                    if (!isNullOrUndefined(annotation.IsPrint)) {
                        isPrint = annotation.IsPrint;
                    }
                    else {
                        isPrint = !isNullOrUndefined(annotation.isPrint) ? annotation.isPrint : annotation.AnnotationSettings.isPrint;
                    }
                    if (annotation.IsLocked) {
                        annotation.AnnotationSettings.isLock = annotation.IsLocked;
                    }
                    // Create redaction annotation object
                    annotationObject = {
                        shapeAnnotationType: 'Redaction',
                        author: author,
                        modifiedDate: annotation.ModifiedDate || new Date().toLocaleString(),
                        subject: annotation.Subject || '',
                        note: annotation.Note || '',
                        bounds: {
                            left: position.X,
                            top: position.Y,
                            width: position.Width,
                            height: position.Height,
                            right: position.Right,
                            bottom: position.Bottom
                        },
                        rotateAngle: annotation.RotateAngle || '0',
                        isLocked: annotation.IsLocked || false,
                        annotName: annotation.AnnotName,
                        pageNumber: pageNumber,
                        annotationSelectorSettings: annotation.AnnotationSelectorSettings || this.pdfViewer.annotationSelectorSettings,
                        customData: this.pdfViewer.annotation.getCustomData(annotation),
                        overlayText: annotation.OverlayText || '',
                        isRepeat: annotation.IsRepeat,
                        fontColor: annotation.FontColor || 'rgba(255, 0, 0, 1)',
                        fillColor: annotation.FillColor || 'rgba(0, 0, 0, 1)',
                        fontSize: annotation.FontSize || 14,
                        fontFamily: annotation.FontFamily || 'Helvetica',
                        textAlign: annotation.TextAlign || 'center',
                        markerFillColor: annotation.MarkerFillColor || 'rgba(255, 255, 255, 1)',
                        markerBorderColor: annotation.MarkerBorderColor || 'rgba(255, 0, 0, 1)',
                        markerOpacity: annotation.MarkerOpacity || 1,
                        annotationSettings: annotation.AnnotationSettings,
                        allowedInteractions: annotation.allowedInteractions,
                        isPrint: isPrint,
                        annotationId: annotation.AnnotName || '',
                        id: (annotation.Id || ('redaction' + this.redactionCount++) || this.pdfViewer.annotationModule.createGUID() || 'redaction_id'),
                        comments: this.pdfViewer.annotationModule.getAnnotationComments(annotation.Comments, annotation, annotation.Author),
                        review: {
                            state: annotation.State, stateModel: annotation.StateModel,
                            modifiedDate: annotation.ModifiedDate, author: annotation.Author
                        },
                        isCommentLock: false,
                        isReadonly: annotation.IsReadonly || false,
                        annotationIndex: annotation.AnnotationIndex,
                        originalName: annotation.OriginalName ? annotation.OriginalName : null, status: annotation.Status
                    };
                    // Create PdfAnnotationBaseModel for redaction
                    var annot = {
                        author: author,
                        annotationIndex: annotation.AnnotationIndex,
                        modifiedDate: annotationObject.modifiedDate,
                        annotName: annotationObject.annotName,
                        pageIndex: pageNumber,
                        bounds: {
                            x: position.X,
                            y: position.Y,
                            width: position.Width,
                            height: position.Height
                        },
                        strokeColor: annotationObject.markerBorderColor,
                        fillColor: annotationObject.fillColor,
                        thickness: 1,
                        comments: this.pdfViewer.annotationModule.getAnnotationComments(annotation.Comments, annotation, annotation.Author),
                        id: annotationObject.id,
                        shapeAnnotationType: 'Redaction',
                        annotType: 'Redaction',
                        subject: annotationObject.subject,
                        notes: annotationObject.note,
                        annotationSelectorSettings: annotationObject.annotationSelectorSettings,
                        annotationSettings: annotationObject.annotationSettings,
                        annotationAddMode: annotation.annotationAddMode,
                        allowedInteractions: annotation.allowedInteractions,
                        isLocked: annotation.isLocked,
                        isPrint: isPrint,
                        overlayText: annotationObject.overlayText,
                        isRepeat: annotationObject.isRepeat,
                        markerFillColor: annotationObject.markerFillColor,
                        markerBorderColor: annotationObject.markerBorderColor || 'rgba(255, 0, 0, 1)',
                        markerOpacity: annotationObject.markerOpacity || 1,
                        fontColor: annotationObject.fontColor,
                        fontSize: annotationObject.fontSize,
                        fontFamily: annotationObject.fontFamily,
                        textAlign: annotationObject.textAlign,
                        status: annotationObject.status
                    };
                    // Add the annotation to the viewer
                    this.pdfViewer.add(annot);
                    // // Draw the redaction annotation
                    this.drawRedactionAnnotation(pageNumber, annot);
                    // Store in session storage
                    this.pdfViewer.annotationModule.storeAnnotations(pageNumber, annotationObject, '_annotations_redaction');
                    // Fire annotation add event if needed
                    if (this.isAddAnnotationProgramatically) {
                        var settings = {
                            shapeAnnotationType: annotationObject.shapeAnnotationType,
                            markerBorderColor: annot.strokeColor,
                            markerFillColor: annotationObject.markerFillColor,
                            opacity: annot.opacity,
                            overlayText: annotationObject.overlayText || '',
                            fontColor: annotationObject.fontColor,
                            fontSize: annotationObject.fontSize || 14,
                            fontFamily: annotationObject.fontFamily,
                            textAlign: annotationObject.textAlign,
                            author: author,
                            subject: annotationObject.subject,
                            modifiedDate: annotationObject.modifiedDate
                        };
                        this.pdfViewer.fireAnnotationAdd(annot.pageIndex || 0, annot.annotName || '', 'Redaction', annot.bounds, settings);
                    }
                }
                if (this.pdfViewer.toolbarModule && this.pdfViewer.toolbarModule.redactionToolbarModule) {
                    this.pdfViewer.toolbarModule.redactionToolbarModule.showHideRedactIcon(true);
                }
            }
            else if (redactionAnnotations.shapeAnnotationType && redactionAnnotations.shapeAnnotationType === 'Redaction') {
                var annotation = this.createAnnotationObject(redactionAnnotations);
                if (!isNullOrUndefined(redactionAnnotations.formFieldAnnotationType) &&
                    redactionAnnotations.formFieldAnnotationType !== '') {
                    this.pdfViewer.annotationModule.isFormFieldShape = true;
                }
                else {
                    this.pdfViewer.annotationModule.isFormFieldShape = false;
                }
                if (annotation) {
                    this.pdfViewer.annotationModule.storeAnnotations(pageNumber, annotation, '_annotations_redaction');
                    this.pdfViewer.annotationModule.triggerAnnotationAdd(redactionAnnotations);
                }
            }
        }
    };
    Redaction.prototype.createAnnotationObject = function (annotation) {
        var bounds;
        var annotationName = this.pdfViewer.annotation.createGUID();
        if (!annotation.formFieldAnnotationType) {
            var commentsDivid = this.pdfViewer.annotation.stickyNotesAnnotationModule.addComments('redaction', (annotation.pageIndex + 1), annotation.shapeAnnotationType);
            if (commentsDivid) {
                document.getElementById(commentsDivid).id = annotationName;
            }
        }
        if (annotation.id) {
            var obj = this.pdfViewer.nameTable[annotation.id];
            this.updateRedactionProperties(obj);
        }
        annotation.annotName = annotationName;
        if (annotation.wrapper.bounds) {
            bounds = {
                left: annotation.wrapper.bounds.x,
                top: annotation.wrapper.bounds.y, height: annotation.wrapper.bounds.height, width: annotation.wrapper.bounds.width,
                right: annotation.wrapper.bounds.right, bottom: annotation.wrapper.bounds.bottom
            };
        }
        else {
            bounds = {
                left: 0, top: 0, height: 0, width: 0, right: 0, bottom: 0
            };
        }
        var annotationObject = {
            shapeAnnotationType: 'Redaction',
            status: AnnotationStatus.NewlyAdded,
            author: annotation.author,
            modifiedDate: annotation.modifiedDate || new Date().toLocaleString(),
            subject: annotation.subject || '',
            note: annotation.note || '',
            bounds: bounds,
            rotateAngle: annotation.rotateAngle || '0',
            isLocked: annotation.isLocked || false,
            annotName: annotation.annotName,
            pageNumber: annotation.pageIndex,
            annotationSelectorSettings: annotation.annotationSelectorSettings || this.pdfViewer.annotationSelectorSettings,
            customData: this.pdfViewer.redactionSettings.customData || {},
            overlayText: annotation.overlayText || '',
            isRepeat: annotation.isRepeat,
            fontColor: annotation.fontColor || 'rgba(255, 0, 0, 1)',
            fillColor: annotation.fillColor || 'rgba(0, 0, 0, 1)',
            fontSize: annotation.fontSize || 14,
            fontFamily: annotation.fontFamily || 'Helvetica',
            textAlign: annotation.textAlign || 'center',
            markerFillColor: annotation.markerFillColor || 'rgba(255, 255, 255, 1)',
            markerBorderColor: annotation.markerBorderColor || 'rgba(255, 0, 0, 1)',
            markerOpacity: annotation.markerOpacity || 1,
            annotationSettings: annotation.annotationSettings,
            allowedInteractions: this.pdfViewer.annotationModule.updateAnnotationAllowedInteractions(annotation),
            isPrint: annotation.isPrint,
            annotationId: annotation.annotName || '',
            id: annotation.id || '',
            comments: annotation.comments,
            isCommentLock: annotation.isCommentLock,
            isReadonly: annotation.isReadonly || false,
            review: {
                state: '',
                stateModel: '',
                modifiedDate: this.pdfViewer.annotation.stickyNotesAnnotationModule.getDateAndTime(),
                author: annotation.author
            }
        };
        this.updateRedactionProperties(annotationObject);
        return annotationObject;
    };
    Redaction.prototype.updateRedactionProperties = function (annotation) {
        if (!this.pdfViewer.redactionSettings) {
            return;
        }
        var rs = this.pdfViewer.redactionSettings;
        annotation.fillColor = !isNullOrUndefined(rs.fillColor) ? rs.fillColor : !isNullOrUndefined(annotation.fillColor) ? annotation.fillColor : 'rgba(0, 0, 0, 1)';
        annotation.fontColor = !isNullOrUndefined(rs.fontColor) ? rs.fontColor : !isNullOrUndefined(annotation.fontColor) ? annotation.fontColor : 'rgba(255, 0, 0, 1)';
        annotation.isRepeat = !isNullOrUndefined(rs.isRepeat) ? rs.isRepeat :
            !isNullOrUndefined(annotation.isRepeat) ? annotation.isRepeat : false;
        annotation.overlayText = !isNullOrUndefined(rs.overlayText) ? rs.overlayText : !isNullOrUndefined(annotation.overlayText) ? annotation.overlayText : '';
        annotation.fontSize = !isNullOrUndefined(rs.fontSize) ? rs.fontSize :
            !isNullOrUndefined(annotation.fontSize) ? annotation.fontSize : 14;
        annotation.fontFamily = !isNullOrUndefined(rs.fontFamily) ? rs.fontFamily : !isNullOrUndefined(annotation.fontFamily) ? annotation.fontFamily : 'Helvetica';
        annotation.textAlign = !isNullOrUndefined(rs.textAlignment) ? rs.textAlignment : !isNullOrUndefined(annotation.textAlign) ? annotation.textAlign : 'center';
        annotation.markerFillColor = !isNullOrUndefined(rs.markerFillColor) ? rs.markerFillColor : !isNullOrUndefined(annotation.markerFillColor) ? annotation.markerFillColor : 'rgba(255, 255, 255, 1)';
        annotation.markerBorderColor = !isNullOrUndefined(rs.markerBorderColor) ? rs.markerBorderColor : !isNullOrUndefined(annotation.markerBorderColor) ? annotation.markerBorderColor : 'rgba(255, 0, 0, 1)';
        annotation.markerOpacity = !isNullOrUndefined(rs.markerOpacity) ? rs.markerOpacity :
            !isNullOrUndefined(annotation.markerOpacity) ? annotation.markerOpacity : 1;
    };
    Redaction.prototype.drawRedactionAnnotation = function (pageNumber, annotation, canvas) {
        var bounds = annotation.bounds;
        if (canvas) {
            this.pdfViewer.renderDrawing(canvas, pageNumber);
        }
        else {
            var canvasElement = this.pdfViewerBase.getAnnotationCanvas('_annotationCanvas_', pageNumber);
            if (canvasElement) {
                this.pdfViewer.renderDrawing(canvasElement, pageNumber);
            }
        }
    };
    /**
     * Get annotation settings specific to redaction
     * @param {any} annotation - The annotation to get settings for
     * @returns {any} The annotation settings
     * @private
     */
    Redaction.prototype.getSettings = function (annotation) {
        var settings = {};
        settings.pageNumber = annotation.pageNumber;
        settings.bounds = annotation.bounds;
        settings.annotationSelectorSettings = this.getSelector('Redaction', annotation.subject);
        settings.markerFillColor = annotation.markerFillColor || this.redactionFillColor;
        settings.markerBorderColor = annotation.markerBorderColor || this.redactionBorderColor;
        settings.markerOpacity = annotation.markerOpacity || this.redactionOutlineOpacity;
        // settings.opacity = annotation.opacity || this.redactionOpacity;
        settings.overlayText = annotation.overlayText || '';
        settings.fontColor = annotation.fontColor || 'rgba(255, 0, 0, 1)';
        settings.fontSize = annotation.fontSize || 14;
        settings.fontFamily = annotation.fontFamily || 'Helvetica';
        settings.textAlign = annotation.textAlign || 'center';
        return settings;
    };
    /**
     * Set annotation type to Redaction
     * @param {AnnotationType} type - The annotation type
     * @returns {void}
     * @private
     */
    Redaction.prototype.setAnnotationType = function (type) {
        if (type === 'Redaction') {
            this.initializeRedactionProperties();
            // this.pdfViewerBase.disableTextSelectionMode();
            var modifiedDate = this.pdfViewer.annotation.stickyNotesAnnotationModule.getDateAndTime();
            var author = (this.pdfViewer.annotationSettings.author !== 'Guest') ?
                this.pdfViewer.annotationSettings.author :
                (this.pdfViewer.redactionSettings && this.pdfViewer.redactionSettings.author) ?
                    this.pdfViewer.redactionSettings.author : 'Guest';
            var opacity = this.pdfViewer.redactionSettings.markerOpacity ? (this.pdfViewer.redactionSettings.markerOpacity > 1 ?
                (this.pdfViewer.redactionSettings.markerOpacity / 100) : this.pdfViewer.redactionSettings.markerOpacity) : 1;
            this.pdfViewer.drawingObject = {
                shapeAnnotationType: 'Redaction',
                // type: 'Redaction',
                strokeColor: this.redactionBorderColor,
                fillColor: this.pdfViewer.redactionSettings.fillColor || 'rgba(0, 0, 0, 1)',
                fontColor: this.pdfViewer.redactionSettings.fontColor || 'rgba(255, 0, 0, 1)',
                opacity: opacity,
                notes: '',
                thickness: 1,
                fontSize: 14,
                fontFamily: 'Helvetica',
                borderDashArray: '0',
                textAlign: 'center',
                modifiedDate: modifiedDate,
                author: author,
                subject: 'Redaction',
                overlayText: this.pdfViewer.redactionSettings.overlayText || '',
                markerFillColor: this.redactionMarkerFillColor,
                markerBorderColor: this.redactionBorderColor,
                markerOpacity: this.redactionOutlineOpacity,
                isCommentLock: false
            };
            this.pdfViewer.tool = 'DrawTool';
        }
    };
    /**
     * Update redaction annotation collections
     * @param {any} annotation - The annotation to update
     * @param {number} pageNumber - The page number
     * @returns {IRedactionAnnotation | null} The updated annotation object
     * @private
     */
    Redaction.prototype.updateRedactionAnnotationCollections = function (annotation, pageNumber) {
        var currentAnnotObject = null;
        if (annotation) {
            var isLock = false;
            if (annotation.IsLocked) {
                isLock = annotation.IsLocked;
            }
            var author = annotation.Author || '';
            var allowedInteractions = annotation.AllowedInteractions ||
                this.pdfViewer.annotationModule.updateAnnotationAllowedInteractions(annotation);
            if (annotation.Bound) {
                var annotationObject = {
                    id: 'redaction' + this.redactionCount++,
                    shapeAnnotationType: 'Redaction',
                    annotationIndex: annotation.AnnotationIndex,
                    author: author,
                    modifiedDate: annotation.ModifiedDate || new Date().toLocaleString(),
                    subject: annotation.Subject || '',
                    note: annotation.Note || '',
                    overlayText: annotation.OverlayText || '',
                    fontColor: annotation.FontColor || 'rgba(255, 0, 0, 1)',
                    fontSize: annotation.FontSize || 14,
                    fontFamily: annotation.FontFamily || 'Helvetica',
                    textAlign: annotation.TextAlign || 'center',
                    markerFillColor: annotation.MarkerFillColor || 'rgba(255, 255, 255, 1)',
                    markerBorderColor: annotation.MarkerBorderColor || 'rgba(255, 0, 0, 1)',
                    markerOpacity: annotation.MarkerOpacity || 1,
                    fillColor: annotation.fillColor || 'rgba(0, 0, 0, 1)',
                    isRepeat: annotation.IsRepeat || false,
                    bounds: {
                        left: annotation.Bound.X,
                        top: annotation.Bound.Y,
                        width: annotation.Bound.Width,
                        height: annotation.Bound.Height,
                        right: annotation.Bound.Right,
                        bottom: annotation.Bound.Bottom
                    },
                    rotateAngle: annotation.RotateAngle || '0',
                    isLocked: isLock,
                    annotationId: annotation.AnnotName,
                    pageNumber: pageNumber,
                    customData: this.pdfViewer.annotation.getCustomData(annotation),
                    allowedInteractions: allowedInteractions,
                    annotName: annotation.AnnotName,
                    annotationSelectorSettings: this.getSelector('Redaction', annotation.Subject),
                    annotationSettings: annotation.AnnotationSettings ||
                        // eslint-disable-next-line security/detect-object-injection
                        { minWidth: 0, minHeight: 0, maxHeight: this.pdfViewerBase.pageSize[pageNumber].height,
                            // eslint-disable-next-line security/detect-object-injection
                            maxWidth: this.pdfViewerBase.pageSize[pageNumber].width, isPrint: true, isLock: false },
                    isPrint: annotation.IsPrint !== undefined ? annotation.IsPrint : true,
                    comments: annotation.Comments ? this.pdfViewer.annotationModule.getAnnotationComments(annotation.Comments, annotation, annotation.Author) : [],
                    review: {
                        state: annotation.State,
                        stateModel: annotation.StateModel,
                        modifiedDate: annotation.ModifiedDate,
                        author: annotation.Author
                    },
                    isCommentLock: annotation.IsCommentLock,
                    // Add the missing properties:
                    isReadonly: annotation.IsReadonly || false
                };
                if (annotationObject.isLocked) {
                    annotationObject.annotationSettings.isLock = annotationObject.isLocked;
                }
                currentAnnotObject = annotationObject;
            }
        }
        return currentAnnotObject;
    };
    /**
     * Modify redaction annotation in collection
     * @param {string} property - The property to modify
     * @param {number} pageNumber - The page number
     * @param {any} annotationBase - The annotation to modify
     * @returns {IRedactionAnnotation | null} The modified annotation
     * @private
     */
    Redaction.prototype.modifyInCollection = function (property, pageNumber, annotationBase) {
        if (!isNullOrUndefined(annotationBase.formFieldAnnotationType) &&
            annotationBase.formFieldAnnotationType !== '') {
            this.pdfViewer.annotationModule.isFormFieldShape = true;
        }
        else {
            this.pdfViewer.annotationModule.isFormFieldShape = false;
        }
        this.pdfViewerBase.updateDocumentEditedProperty(true);
        var currentAnnotObject = null;
        if (annotationBase) {
            if (property === 'bounds') {
                this.pdfViewer.annotationModule.stickyNotesAnnotationModule.updateAnnotationModifiedDate(annotationBase, true);
            }
        }
        var pageAnnotations = this.getAnnotations(pageNumber, null);
        if (pageAnnotations != null && annotationBase) {
            for (var i = 0; i < pageAnnotations.length; i++) {
                if (annotationBase.id === pageAnnotations[i].id ||
                    annotationBase.annotName === pageAnnotations[i].annotName) {
                    if (property === 'bounds') {
                        pageAnnotations[i].bounds = {
                            // x: annotationBase.bounds.x,
                            // y: annotationBase.bounds.y,
                            left: annotationBase.bounds.x,
                            top: annotationBase.bounds.y,
                            height: annotationBase.bounds.height,
                            width: annotationBase.bounds.width,
                            right: annotationBase.bounds.right ? annotationBase.bounds.right : annotationBase.wrapper.bounds.right,
                            bottom: annotationBase.bounds.bottom ? annotationBase.bounds.bottom : annotationBase.wrapper.bounds.bottom
                        };
                    }
                    else if (property === 'fillColor') {
                        pageAnnotations[i].fillColor = annotationBase.fillColor;
                    }
                    else if (property === 'useOverlayText') {
                        pageAnnotations[i].useOverlayText = annotationBase.useOverlayText;
                    }
                    else if (property === 'isRepeat') {
                        pageAnnotations[i].isRepeat = annotationBase.isRepeat;
                    }
                    else if (property === 'fill') {
                        pageAnnotations[i].markerFillColor = annotationBase.wrapper.children[0].style.fill;
                    }
                    else if (property === 'stroke') {
                        pageAnnotations[i].markerBorderColor = annotationBase.wrapper.children[0].style.strokeColor;
                    }
                    else if (property === 'opacity') {
                        pageAnnotations[i].markerOpacity = annotationBase.markerOpacity;
                    }
                    else if (property === 'overlayText') {
                        pageAnnotations[i].overlayText = annotationBase.overlayText;
                    }
                    else if (property === 'fontColor') {
                        pageAnnotations[i].fontColor = annotationBase.fontColor;
                    }
                    else if (property === 'fontSize') {
                        pageAnnotations[i].fontSize = annotationBase.fontSize;
                    }
                    else if (property === 'fontFamily') {
                        pageAnnotations[i].fontFamily = annotationBase.fontFamily;
                    }
                    else if (property === 'textAlign') {
                        pageAnnotations[i].textAlign = annotationBase.textAlign;
                    }
                    else if (property === 'notes') {
                        pageAnnotations[i].note = annotationBase.notes;
                    }
                    else if (property === 'delete') {
                        currentAnnotObject = pageAnnotations.splice(i, 1)[0];
                        break;
                    }
                    else if (property === 'isLock') {
                        if (pageAnnotations[i].annotationSettings) {
                            pageAnnotations[i].annotationSettings.isLock = annotationBase.isLock;
                        }
                        pageAnnotations[i].isLock = annotationBase.isLock;
                    }
                    else if (property === 'allowedInteractions') {
                        pageAnnotations[i].allowedInteractions = annotationBase.allowedInteractions;
                    }
                    else if (property === 'isPrint') {
                        if (pageAnnotations[i].annotationSettings) {
                            pageAnnotations[i].annotationSettings.isPrint = annotationBase.isPrint;
                        }
                        pageAnnotations[i].isPrint = annotationBase.isPrint;
                    }
                    if (pageAnnotations[i].status !== 'NewlyAdded') {
                        pageAnnotations[i].status = AnnotationStatus.ExistingModified;
                    }
                    this.pdfViewer.annotationModule.storeAnnotationCollections(pageAnnotations[i], pageNumber);
                }
            }
            this.manageAnnotations(pageAnnotations, pageNumber);
        }
        return currentAnnotObject;
    };
    /**
     * Add redaction annotation to collection
     * @param {number} pageNumber - The page number
     * @param {IRedactionAnnotation} annotationBase - The annotation to add
     * @returns {void} - void
     * @private
     */
    Redaction.prototype.addInCollection = function (pageNumber, annotationBase) {
        var pageAnnotations = this.getAnnotations(pageNumber, null);
        if (pageAnnotations) {
            pageAnnotations.push(annotationBase);
        }
        this.manageAnnotations(pageAnnotations, pageNumber);
    };
    /**
     * Manage annotations in storage
     * @param {IRedactionAnnotation[]} pageAnnotations - The annotations for the page
     * @param {number} pageNumber - The page number
     * @returns {void} - void
     * @private
     */
    Redaction.prototype.manageAnnotations = function (pageAnnotations, pageNumber) {
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_redaction');
        if (storeObject) {
            this.pdfViewer.annotationsCollection.delete(this.pdfViewerBase.documentId + '_annotations_redaction');
            var index = this.pdfViewer.annotationModule.getPageCollection(storeObject, pageNumber);
            if (index != null && storeObject[parseInt(index.toString(), 10)]) {
                storeObject[parseInt(index.toString(), 10)].annotations = pageAnnotations;
            }
            this.pdfViewer.annotationsCollection.set(this.pdfViewerBase.documentId + '_annotations_redaction', storeObject);
        }
    };
    /**
     * Save imported redaction annotations
     * @param {any} annotation - The annotation to save
     * @param {number} pageIndex - The page index
     * @returns {void} - void
     * @private
     */
    Redaction.prototype.saveImportedRedactionAnnotations = function (annotation, pageIndex) {
        if (annotation) {
            var annotationObject = {
                shapeAnnotationType: 'Redaction',
                annotationIndex: annotation.AnnotationIndex,
                status: annotation.status,
                author: annotation.Author || '',
                modifiedDate: annotation.ModifiedDate || new Date().toLocaleString(),
                subject: annotation.Subject || '',
                note: annotation.Note || '',
                bounds: {
                    // x: annotation.Bounds.X,
                    // y: annotation.Bounds.Y,
                    left: annotation.Bounds.X,
                    top: annotation.Bounds.Y,
                    width: annotation.Bounds.Width,
                    height: annotation.Bounds.Height,
                    right: annotation.Bounds.X + annotation.Bounds.Width,
                    bottom: annotation.Bounds.Y + annotation.Bounds.Height
                },
                rotateAngle: annotation.RotateAngle || '0',
                isLocked: annotation.IsLocked || false,
                annotName: annotation.AnnotName,
                pageNumber: pageIndex,
                annotationId: annotation.AnnotName,
                annotationSelectorSettings: annotation.AnnotationSelectorSettings || this.pdfViewer.annotationSelectorSettings,
                customData: this.pdfViewer.annotation.getCustomData(annotation),
                overlayText: annotation.OverlayText || '',
                isRepeat: annotation.IsRepeat || false,
                fontColor: annotation.FontColor || 'rgba(255, 0, 0, 1)',
                fillColor: annotation.FillColor || 'rgba(0, 0, 0, 1)',
                fontSize: annotation.FontSize || 14,
                fontFamily: annotation.FontFamily || 'Helvetica',
                textAlign: annotation.TextAlign || 'center',
                markerFillColor: annotation.MarkerFillColor || 'rgba(255, 255, 255, 1)',
                markerBorderColor: annotation.MarkerBorderColor || 'rgba(255, 0, 0, 1)',
                markerOpacity: annotation.MarkerOpacity || 1,
                isPrint: annotation.IsPrint !== undefined ? annotation.IsPrint : true,
                id: (annotation.Id || this.pdfViewer.annotationModule.createGUID() || 'redaction_id'),
                comments: this.pdfViewer.annotationModule.getAnnotationComments(annotation.Comments, annotation, annotation.Author),
                review: {
                    state: annotation.State,
                    stateModel: annotation.StateModel,
                    modifiedDate: annotation.ModifiedDate,
                    author: annotation.Author
                },
                isCommentLock: annotation.IsCommentLock || false,
                isReadonly: annotation.IsReadonly || false,
                annotationSettings: annotation.AnnotationSettings || this.pdfViewer.annotationModule.updateAnnotationSettings(annotation),
                allowedInteractions: annotation.AllowedInteractions ||
                    this.pdfViewer.annotationModule.updateAnnotationAllowedInteractions(annotation)
            };
            // Create PdfAnnotationBaseModel for redaction
            var annot = {
                author: annotationObject.author,
                annotationIndex: annotationObject.annotationIndex,
                modifiedDate: annotationObject.modifiedDate,
                annotName: annotationObject.annotName,
                pageIndex: pageIndex,
                bounds: {
                    left: annotationObject.bounds.left,
                    top: annotationObject.bounds.top,
                    width: annotationObject.bounds.width,
                    height: annotationObject.bounds.height
                },
                strokeColor: annotationObject.markerBorderColor,
                fillColor: annotationObject.fillColor,
                opacity: annotationObject.markerOpacity,
                thickness: 1,
                id: annotationObject.annotName,
                shapeAnnotationType: 'Redaction',
                annotType: 'Redaction',
                subject: annotationObject.subject,
                notes: annotationObject.note,
                annotationSelectorSettings: annotationObject.annotationSelectorSettings,
                annotationSettings: annotationObject.annotationSettings,
                annotationAddMode: 'Imported Annotation',
                isLocked: annotationObject.isLocked,
                isPrint: annotationObject.isPrint,
                overlayText: annotationObject.overlayText,
                isRepeat: annotationObject.isRepeat,
                markerFillColor: annotationObject.markerFillColor,
                markerBorderColor: annotationObject.markerBorderColor,
                markerOpacity: annotationObject.markerOpacity,
                fontColor: annotationObject.fontColor,
                fontSize: annotationObject.fontSize,
                fontFamily: annotationObject.fontFamily,
                textAlign: annotationObject.textAlign
            };
            // Add the annotation to the viewer
            this.pdfViewer.add(annot);
            // Store in session storage
            this.pdfViewer.annotationModule.storeAnnotations(pageIndex, annotationObject, '_annotations_redaction');
        }
    };
    /**
     * Get selector settings for redaction annotation
     * @param {string} type - The annotation type
     * @param {string} subject - The annotation subject
     * @returns {AnnotationSelectorSettingsModel} The selector settings
     * @private
     */
    Redaction.prototype.getSelector = function (type, subject) {
        return {
            resizerShape: 'Square',
            resizerSize: 8,
            resizerFillColor: '#FF4081',
            resizerBorderColor: '#FF4081',
            selectionBorderColor: '#FF4081'
        };
    };
    /**
     * Save redaction annotations to JSON format for export
     * @returns {string} JSON string of redaction annotations
     * @private
     */
    Redaction.prototype.saveRedactionAnnotations = function () {
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_redaction');
        var annotations = [];
        for (var j = 0; j < this.pdfViewerBase.pageCount; j++) {
            annotations[j] = [];
        }
        if (storeObject && !this.pdfViewer.annotationSettings.skipDownload) {
            var annotationCollection = JSON.parse(JSON.stringify(storeObject));
            for (var i = 0; i < annotationCollection.length; i++) {
                var newArray = [];
                var pageAnnotationObject = annotationCollection[i];
                if (pageAnnotationObject) {
                    for (var z = 0; pageAnnotationObject.annotations.length > z; z++) {
                        if (this.pdfViewer.printModule && this.pdfViewer.printModule.canPrint &&
                            pageAnnotationObject.annotations[parseInt(z.toString(), 10)].isPrint === false) {
                            pageAnnotationObject.annotations.splice(parseInt(z.toString(), 10), 1);
                            z--;
                            continue;
                        }
                        this.pdfViewer.annotationModule.updateModifiedDate(pageAnnotationObject.annotations[z]);
                        var bounds = pageAnnotationObject.annotations[z].bounds;
                        if (pageAnnotationObject.annotations[z].bounds.length > 1) {
                            bounds = this.combineBounds(pageAnnotationObject.annotations[z], true);
                        }
                        // Convert properties to the expected format
                        pageAnnotationObject.annotations[z].bounds = JSON.stringify(this.pdfViewer.annotation
                            .getBounds(bounds, pageAnnotationObject.pageIndex));
                        var markerFillColorString = pageAnnotationObject.annotations[z].markerFillColor || '';
                        pageAnnotationObject.annotations[z].markerFillColor =
                            JSON.stringify(this.getRgbCode(markerFillColorString));
                        var markerBorderColorString = pageAnnotationObject.annotations[z].markerBorderColor || '';
                        pageAnnotationObject.annotations[z].markerBorderColor =
                            JSON.stringify(this.getRgbCode(markerBorderColorString));
                        var fillColorString = pageAnnotationObject.annotations[z].fillColor || '';
                        pageAnnotationObject.annotations[z].fillColor = JSON.stringify(this.getRgbCode(fillColorString));
                        var opacity = pageAnnotationObject.annotations[z].markerOpacity > 1 ?
                            pageAnnotationObject.annotations[z].markerOpacity / 100 :
                            pageAnnotationObject.annotations[z].markerOpacity;
                        pageAnnotationObject.annotations[z].markerOpacity = opacity;
                        if (pageAnnotationObject.annotations[z].fontColor) {
                            var fontColorString = pageAnnotationObject.annotations[z].fontColor || '';
                            pageAnnotationObject.annotations[z].fontColor = JSON.stringify(this.getRgbCode(fontColorString));
                        }
                        if (isNullOrUndefined(pageAnnotationObject.annotations[z].status) && this.pdfViewerBase.canRedact) {
                            pageAnnotationObject.annotations[z].status = AnnotationStatus.ExistingModified;
                        }
                    }
                    pageAnnotationObject.annotations = pageAnnotationObject.annotations.filter(function (item) { return item; });
                    newArray = pageAnnotationObject.annotations;
                }
                annotations[pageAnnotationObject.pageIndex] = newArray;
            }
        }
        return JSON.stringify(annotations);
    };
    /**
     * Save redaction annotations to JSON format for export
     * @param {any} newAnnotation - new annotation
     * @param {boolean} canSaved - can saved
     * @private
     * @returns {any} - JSON string of redaction annotations
     */
    Redaction.prototype.combineBounds = function (newAnnotation, canSaved) {
        var combineBounds = [];
        var newBounds = [];
        var x = 0;
        var y = 0;
        var width = 0;
        var height = 0;
        var currentTop = 0;
        var nextTop = 0;
        var currentLeft = 0;
        var nextLeft = 0;
        var currentRotation = 0;
        var isEqual = false;
        for (var i = 0; i < newAnnotation.bounds.length; i++) {
            var newAnnotationBounds = newAnnotation.bounds[parseInt(i.toString(), 10)];
            currentTop = newAnnotationBounds.top ?
                newAnnotationBounds.top : newAnnotationBounds.Top;
            nextTop = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ? newAnnotation.bounds[i + 1].top ?
                newAnnotation.bounds[i + 1].top : newAnnotation.bounds[i + 1].Top : 0;
            currentLeft = newAnnotationBounds.left ?
                newAnnotationBounds.left : newAnnotationBounds.Left;
            nextLeft = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ? newAnnotation.bounds[i + 1].left ?
                newAnnotation.bounds[i + 1].left : newAnnotation.bounds[i + 1].Left : 0;
            var pageRotate = this.pdfViewerBase.pageSize[newAnnotation.pageNumber].rotation;
            currentRotation = !isNullOrUndefined(newAnnotationBounds.rotation) ? newAnnotationBounds.rotation : pageRotate ? pageRotate : 0;
            var rotation180Exists = (currentRotation === 0) || (currentRotation === 2) || (currentRotation === 180);
            if (rotation180Exists) {
                var currentRight = newAnnotationBounds.right ?
                    newAnnotationBounds.right : newAnnotationBounds.Right;
                var nextRight = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ?
                    newAnnotation.bounds[i + 1].right ? newAnnotation.bounds[i + 1].right : newAnnotation.bounds[i + 1].Right : 0;
                isEqual = ((nextRight === 0 || Math.abs(currentLeft - nextRight) < 0.5) ||
                    (nextLeft === 0 || Math.abs(currentRight - nextLeft) < 0.5));
            }
            else {
                var currentBottom = newAnnotationBounds.bottom ? newAnnotationBounds.bottom : newAnnotationBounds.Bottom;
                var nextBottom = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ? newAnnotation.bounds[i + 1].bottom ?
                    newAnnotation.bounds[i + 1].bottom : newAnnotation.bounds[i + 1].Bottom : 0;
                isEqual = (nextBottom === 0 || (Math.abs(nextBottom - currentTop) < 0.5) || Math.abs(nextTop - currentBottom) < 0.5);
            }
            if (newAnnotation.bounds.length > 1 && i < newAnnotation.bounds.length - 1 && (currentTop === nextTop ||
                currentLeft === nextLeft) && isEqual) {
                newBounds.push(newAnnotationBounds);
            }
            else {
                if (i === newAnnotation.bounds.length - 1 || newAnnotation.bounds.length >= 1) {
                    newBounds.push(newAnnotationBounds);
                }
                if (newBounds.length >= 1) {
                    x = newBounds.reduce(function (min, rect) { return (rect.left ? rect.left : rect.Left || 0) < min ?
                        (rect.left ? rect.left : rect.Left || 0) : min; }, Infinity);
                    y = newBounds.reduce(function (min, rect) { return (rect.top ? rect.top : rect.Top || 0) < min ?
                        (rect.top ? rect.top : rect.Top || 0) : min; }, Infinity);
                    if (!this.pdfViewerBase.clientSideRendering || rotation180Exists) {
                        if (!rotation180Exists) {
                            width = newBounds[0].width ? newBounds[0].width : newBounds[0].Width;
                        }
                        else {
                            height = newBounds[0].height ? newBounds[0].height : newBounds[0].Height;
                        }
                        for (var j = 0; j < newBounds.length; j++) {
                            if (!rotation180Exists) {
                                height += newBounds[parseInt(j.toString(), 10)].height ?
                                    newBounds[parseInt(j.toString(), 10)].height : newBounds[parseInt(j.toString(), 10)].Height;
                            }
                            else if ((!isNaN(newBounds[parseInt(j.toString(), 10)].width) &&
                                newBounds[parseInt(j.toString(), 10)].width > 0) || (!isNaN(newBounds[parseInt(j.toString(), 10)].Width) &&
                                newBounds[parseInt(j.toString(), 10)].Width > 0)) {
                                width += newBounds[parseInt(j.toString(), 10)].width ?
                                    newBounds[parseInt(j.toString(), 10)].width : newBounds[parseInt(j.toString(), 10)].Width;
                            }
                        }
                    }
                    else {
                        width += newBounds[0].width ? newBounds[0].width : newBounds[0].Width;
                        height = newBounds.reduce(function (sum, rect) { return sum + (rect.height ? rect.height : rect.Height || 0); }, 0);
                    }
                    if (width !== 0 && height !== 0) {
                        var zoomFactor = this.pdfViewerBase.getZoomFactor();
                        var factor = canSaved ? 1 : zoomFactor;
                        var bounds = {
                            x: this.getMagnifiedValue(x - 0.5, factor),
                            y: this.getMagnifiedValue(y - 0.5, factor),
                            width: this.getMagnifiedValue(width + 0.5, factor),
                            height: this.getMagnifiedValue(height + 0.5, factor),
                            left: this.getMagnifiedValue(x - 0.5, factor),
                            top: this.getMagnifiedValue(y - 0.5, factor)
                        };
                        combineBounds.push(bounds);
                    }
                    newBounds = [];
                    width = 0;
                    height = 0;
                }
            }
        }
        return combineBounds;
    };
    /**
     * @private
     * @returns {void}
     */
    Redaction.prototype.deleteTextRedactAnnotation = function () {
        if (this.pdfViewer.toolbarModule && this.pdfViewer.toolbarModule.redactionToolbarModule) {
            this.pdfViewer.toolbarModule.redactionToolbarModule.clear();
        }
        var textMarkUpModule = this.pdfViewer.annotationModule.textMarkupAnnotationModule;
        if (textMarkUpModule.currentTextMarkupAnnotation) {
            var isLock = false;
            if (textMarkUpModule.currentTextMarkupAnnotation.annotationSettings) {
                isLock = textMarkUpModule.currentTextMarkupAnnotation.annotationSettings.isLock;
                if (this.pdfViewer.annotationModule.checkAllowedInteractions('Delete', textMarkUpModule.currentTextMarkupAnnotation)) {
                    isLock = false;
                }
            }
            if (!isLock) {
                var deletedAnnotation = null;
                textMarkUpModule.showHideDropletDiv(true);
                var annotation = textMarkUpModule.currentTextMarkupAnnotation;
                var pageAnnotations = this.getAnnotations(textMarkUpModule.selectTextMarkupCurrentPage, null);
                if (pageAnnotations) {
                    for (var i = 0; i < pageAnnotations.length; i++) {
                        if (textMarkUpModule.currentTextMarkupAnnotation.annotName ===
                            pageAnnotations[parseInt(i.toString(), 10)].annotName) {
                            deletedAnnotation = pageAnnotations.splice(i, 1)[0];
                            this.pdfViewer.annotationModule.addAction(textMarkUpModule.selectTextMarkupCurrentPage, i, deletedAnnotation, 'Text Markup Deleted', null);
                            textMarkUpModule.currentAnnotationIndex = i;
                            this.pdfViewer.annotation.stickyNotesAnnotationModule.findPosition(deletedAnnotation, 'textMarkup');
                            var removeDiv = document.getElementById(deletedAnnotation.annotName);
                            if (removeDiv) {
                                if (removeDiv.parentElement.childElementCount === 1) {
                                    this.pdfViewer.annotationModule.stickyNotesAnnotationModule.updateAccordionContainer(removeDiv);
                                }
                                else {
                                    removeDiv.remove();
                                }
                            }
                        }
                    }
                    this.pdfViewer.annotationModule.updateAnnotationCollection(textMarkUpModule.currentTextMarkupAnnotation);
                    this.manageAnnotations(pageAnnotations, textMarkUpModule.selectTextMarkupCurrentPage);
                    this.pdfViewer.annotationModule.updateImportAnnotationCollection(textMarkUpModule.currentTextMarkupAnnotation, textMarkUpModule.currentTextMarkupAnnotation.pageNumber, 'Redaction');
                    var annotationId = textMarkUpModule.currentTextMarkupAnnotation.annotName;
                    var annotationBounds = textMarkUpModule.currentTextMarkupAnnotation.bounds;
                    textMarkUpModule.currentTextMarkupAnnotation = null;
                    this.pdfViewer.annotationModule.renderAnnotations(textMarkUpModule.selectTextMarkupCurrentPage, null, null, null);
                    this.pdfViewerBase.updateDocumentEditedProperty(true);
                    textMarkUpModule.currentAnnotationIndex = null;
                    textMarkUpModule.selectTextMarkupCurrentPage = null;
                    if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
                        this.pdfViewer.toolbarModule.annotationToolbarModule.hideMobileAnnotationToolbar();
                        this.pdfViewer.toolbarModule.showToolbar(true);
                    }
                }
            }
        }
    };
    /**
     * @param {MouseEvent} event - It describes about the event
     * @private
     * @returns {void}
     */
    Redaction.prototype.onTextRedactMouseMove = function (event) {
        var eventTarget = event.target;
        var pageIndex = parseInt(eventTarget.id.split('_text_')[1], 10) || parseInt(eventTarget.id.split('_textLayer_')[1], 10) || parseInt(eventTarget.id.split('_annotationCanvas_')[1], 10);
        if (event.target && (eventTarget.id.indexOf('_text') > -1 || eventTarget.id.indexOf('_annotationCanvas') > -1 || eventTarget.classList.contains('e-pv-hyperlink')) && this.pdfViewer.annotation) {
            pageIndex = this.pdfViewer.annotation.getEventPageNumber(event);
            var canvas = this.pdfViewerBase.getElement('_annotationCanvas_' + pageIndex);
            var currentAnnot = this.getCurrentMarkupAnnotation(event.clientX, event.clientY, pageIndex, canvas);
            if (currentAnnot) {
                var annotObject = void 0;
                var annotationKeys = Object.keys(this.pdfViewer.nameTable);
                for (var i = 0; i < annotationKeys.length; i++) {
                    annotObject = this.pdfViewer.nameTable[annotationKeys[parseInt(i.toString(), 10)]];
                    if (!isNullOrUndefined(annotObject) && currentAnnot.annotationId === annotObject.annotName) {
                        annotObject = this.pdfViewer.nameTable[annotationKeys[parseInt(i.toString(), 10)]];
                        break;
                    }
                }
                this.handleRedactionHover(annotObject, annotObject.pageNumber, currentAnnot);
                this.pdfViewerBase.isRedactionMousedOver = true;
            }
            else {
                this.resetRedactionHover();
                this.pdfViewerBase.isRedactionMousedOver = false;
            }
        }
    };
    /**
     * @param {TouchEvent} event - It describes about the event
     * @private
     * @returns {void}
     */
    Redaction.prototype.onTextRedactAnnotationTouchEnd = function (event) {
        var pageNumber = this.pdfViewer.annotationModule.getEventPageNumber(event);
        if (!isNullOrUndefined(pageNumber) && !isNaN(pageNumber)) {
            this.pdfViewer.annotationModule.textMarkupAnnotationModule.clearCurrentAnnotationSelection(pageNumber);
            var touchCanvas = this.pdfViewerBase.getElement('_annotationCanvas_' + pageNumber);
            this.clearCurrentSelectedAnnotation();
            var currentAnnot = this.getCurrentMarkupAnnotation(event.touches[0].clientX, event.touches[0].clientY, pageNumber, touchCanvas);
            if (currentAnnot) {
                this.onTextRedactTouchEnd(currentAnnot, touchCanvas, event, pageNumber);
            }
        }
        else if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
            this.clearAnnotationSelection(pageNumber);
        }
        else {
            this.pdfViewer.annotationModule.textMarkupAnnotationModule.clearCurrentAnnotation();
            this.pdfViewer.annotationModule.textMarkupAnnotationModule.clearCurrentAnnotationSelection(pageNumber);
        }
    };
    Redaction.prototype.onTextRedactTouchEnd = function (currentAnnot, touchCanvas, event, pageNumber) {
        var isLock = false;
        if (currentAnnot.annotationSettings && currentAnnot.annotationSettings.isLock) {
            isLock = currentAnnot.annotationSettings.isLock;
        }
        if (!isLock) {
            this.pdfViewer.annotationModule.textMarkupAnnotationModule.selectAnnotation(currentAnnot, touchCanvas, pageNumber, event);
            this.pdfViewer.annotationModule.textMarkupAnnotationModule.selectTextMarkupCurrentPage = pageNumber;
            var accordionExpand = document.getElementById(this.pdfViewer.element.id + '_accordionContainer' + (pageNumber + 1));
            if (accordionExpand) {
                accordionExpand.ej2_instances[0].expandItem(true);
            }
            var comments = document.getElementById(currentAnnot.annotName);
            if (comments) {
                if (!Browser.isDevice) {
                    comments.firstChild.click();
                }
            }
        }
    };
    /**
     * @private
     * @returns {void}
     */
    Redaction.prototype.clearCurrentSelectedAnnotation = function () {
        this.clearAnnotationSelection(this.pdfViewer.currentPageNumber - 1);
    };
    /**
     * @param {number} pageNumber - It describes about the pageNumber
     * @private
     * @returns {void}
     */
    Redaction.prototype.clearAnnotationSelection = function (pageNumber) {
        var _this = this;
        // Styles need to be applied to both canvases. The 'blendAnnotationsIntoCanvas' is used for highlight annotations.
        var canvasIds = [
            '_annotationCanvas_' + pageNumber,
            '_blendAnnotationsIntoCanvas_' + pageNumber
        ];
        canvasIds.forEach(function (id) {
            var canvas = _this.pdfViewerBase.getElement(id);
            if (canvas) {
                var context = canvas.getContext('2d');
                context.setLineDash([]);
                _this.pdfViewer.annotationModule.renderAnnotations(pageNumber, null, null, null);
            }
        });
    };
    /**
     * @param {MouseEvent} event - It describes about the event
     * @private
     * @returns {void}
     */
    Redaction.prototype.onTextRedactAnnotationMouseUp = function (event) {
        var pageNumber = this.pdfViewer.annotationModule.getEventPageNumber(event);
        if (!isNullOrUndefined(pageNumber) && !isNaN(pageNumber)) {
            var canvas = this.pdfViewerBase.getElement('_annotationCanvas_' + pageNumber);
            this.clearCurrentSelectedAnnotation();
            var currentAnnot = this.getCurrentMarkupAnnotation(event.clientX, event.clientY, pageNumber, canvas);
            if (currentAnnot && !window.getSelection().toString()) {
                this.onTextRedactMouseUp(currentAnnot, event, canvas, pageNumber);
            }
        }
    };
    Redaction.prototype.getCurrentMarkupAnnotation = function (clientX, clientY, pageNumber, canvas) {
        var currentTextRedactAnnotations = [];
        if (canvas) {
            var canvasParentPosition = canvas.parentElement.getBoundingClientRect();
            if (canvas.clientWidth !== canvas.parentElement.clientWidth) {
                canvasParentPosition = canvas.getBoundingClientRect();
            }
            var leftClickPosition = clientX - canvasParentPosition.left;
            var topClickPosition = clientY - canvasParentPosition.top;
            var annotationList = this.getAnnotations(pageNumber, null);
            var isAnnotationGot = false;
            if (annotationList) {
                for (var i = 0; i < annotationList.length; i++) {
                    var annotation = annotationList[parseInt(i.toString(), 10)];
                    for (var j = 0; j < annotation.bounds.length; j++) {
                        var bound = annotation.bounds[parseInt(j.toString(), 10)];
                        var left = bound.left ? bound.left : bound.Left;
                        var top_1 = bound.top ? bound.top : bound.Top;
                        var width = bound.width ? bound.width : bound.Width;
                        var height = bound.height ? bound.height : bound.Height;
                        if (leftClickPosition >= this.getMagnifiedValue(left, this.pdfViewerBase.getZoomFactor()) &&
                            leftClickPosition <= this.getMagnifiedValue(left + width, this.pdfViewerBase.getZoomFactor()) &&
                            topClickPosition >= this.getMagnifiedValue(top_1, this.pdfViewerBase.getZoomFactor()) &&
                            topClickPosition <= this.getMagnifiedValue(top_1 + height, this.pdfViewerBase.getZoomFactor())) {
                            currentTextRedactAnnotations.push(annotation);
                            isAnnotationGot = true;
                        }
                        else {
                            if (isAnnotationGot) {
                                isAnnotationGot = false;
                                break;
                            }
                        }
                    }
                }
            }
            var currentAnnot = null;
            if (currentTextRedactAnnotations.length > 1) {
                currentAnnot = this.compareCurrentAnnotations(currentTextRedactAnnotations);
            }
            else if (currentTextRedactAnnotations.length === 1) {
                currentAnnot = currentTextRedactAnnotations[0];
            }
            return currentAnnot;
        }
        else {
            return null;
        }
    };
    Redaction.prototype.compareCurrentAnnotations = function (annotations) {
        var previousX;
        var currentAnnotation = null;
        for (var i = 0; i < annotations.length; i++) {
            if (i === annotations.length - 1) {
                break;
            }
            var firstAnnotBounds = annotations[parseInt(i.toString(), 10)].bounds;
            var firstXposition = firstAnnotBounds[0].left ? firstAnnotBounds[0].left : firstAnnotBounds[0].Left;
            var firstYposition = firstAnnotBounds[0].top ? firstAnnotBounds[0].top : firstAnnotBounds[0].Top;
            var secondAnnotBounds = annotations[i + 1].bounds;
            var secondXposition = secondAnnotBounds[0].left ? secondAnnotBounds[0].left : secondAnnotBounds[0].Left;
            var secondYposition = secondAnnotBounds[0].top ? secondAnnotBounds[0].top : secondAnnotBounds[0].Top;
            if ((firstXposition < secondXposition) || (firstYposition < secondYposition)) {
                previousX = secondXposition;
                currentAnnotation = annotations[i + 1];
            }
            else {
                previousX = firstXposition;
                currentAnnotation = annotations[parseInt(i.toString(), 10)];
            }
            if (previousX && (i === (annotations.length - 2))) {
                if ((previousX === firstXposition) && (previousX === secondXposition)) {
                    previousX = secondXposition;
                    currentAnnotation = annotations[i + 1];
                }
            }
        }
        return currentAnnotation;
    };
    Redaction.prototype.onTextRedactMouseUp = function (currentAnnot, event, canvas, pageNumber) {
        var isLock = false;
        var isSelection = false;
        if (currentAnnot.annotationSettings && currentAnnot.annotationSettings.isLock) {
            isLock = currentAnnot.annotationSettings.isLock;
            if (isLock && this.pdfViewer.annotationModule.checkAllowedInteractions('Select', currentAnnot)) {
                isLock = false;
                if (this.pdfViewer.annotationModule.checkAllowedInteractions('PropertyChange', currentAnnot)) {
                    isSelection = false;
                }
                else {
                    isSelection = true;
                }
            }
        }
        if (!isLock) {
            var canvasParentPosition = canvas.parentElement.getBoundingClientRect();
            var leftClickPosition = event.clientX - canvasParentPosition.left;
            var topClickPosition = event.clientY - canvasParentPosition.top;
            this.pdfViewer.annotation.textMarkupAnnotationModule.annotationClickPosition = { x: leftClickPosition, y: topClickPosition };
            this.pdfViewer.annotation.textMarkupAnnotationModule.selectAnnotation(currentAnnot, canvas, pageNumber, event);
            this.pdfViewer.toolbarModule.redactionToolbarModule.showHideDeleteIcon(true);
            var commentPanelDiv = document.getElementById(this.pdfViewer.element.id + '_commantPanel');
            if (commentPanelDiv && commentPanelDiv.style.display === 'block') {
                var accordionExpand = document.getElementById(this.pdfViewer.element.id + '_accordionContainer' + (pageNumber + 1));
                if (accordionExpand) {
                    accordionExpand.ej2_instances[0].expandItem(true);
                }
                var comments = document.getElementById(currentAnnot.annotName);
                if (comments) {
                    comments.firstChild.click();
                }
            }
            if (!isBlazor()) {
                if (this.pdfViewer.toolbarModule && this.pdfViewer.toolbarModule.redactionToolbarModule) {
                    this.pdfViewer.toolbarModule.redactionToolbarModule.isToolbarHidden = true;
                    this.pdfViewer.toolbarModule.redactionToolbarModule.
                        showRedactionToolbar(this.pdfViewer.toolbarModule.redactionItem);
                }
                if (currentAnnot) {
                    var annotObject = void 0;
                    var annotationKeys = Object.keys(this.pdfViewer.nameTable);
                    for (var i = 0; i < annotationKeys.length; i++) {
                        annotObject = this.pdfViewer.nameTable[annotationKeys[parseInt(i.toString(), 10)]];
                        if (!isNullOrUndefined(annotObject) && currentAnnot.annotationId === annotObject.annotName) {
                            annotObject = this.pdfViewer.nameTable[annotationKeys[parseInt(i.toString(), 10)]];
                            break;
                        }
                    }
                }
            }
        }
    };
    /**
     * @param {any} textRedactAnnotations - It describes about the text markup annotations
     * @param {number} pageNumber - It describes about the page number
     * @param {boolean} isImportTextMarkup - It describes about the isImportTextMarkup
     * @param {boolean} isAnnotOrderAction - It describes about the isAnnotOrderAction
     * @private
     * @returns {void}
     */
    Redaction.prototype.renderTextRedactAnnotationsInPage = function (textRedactAnnotations, pageNumber, isImportTextMarkup, isAnnotOrderAction) {
        var canvasId = '_annotationCanvas_';
        var canvas = this.pdfViewerBase.getAnnotationCanvas(canvasId, pageNumber);
        if (isImportTextMarkup) {
            this.renderTextRedactAnnotations(null, pageNumber, canvas, this.pdfViewerBase.getZoomFactor());
            this.renderTextRedactAnnotations(textRedactAnnotations, pageNumber, canvas, this.pdfViewerBase.getZoomFactor(), true);
            if (textRedactAnnotations && this.pdfViewer.toolbarModule && this.pdfViewer.toolbarModule.redactionToolbarModule) {
                this.pdfViewer.toolbarModule.redactionToolbarModule.showHideRedactIcon(true);
            }
        }
        else {
            this.renderTextRedactAnnotations(textRedactAnnotations, pageNumber, canvas, this.pdfViewerBase.getZoomFactor(), null, isAnnotOrderAction);
        }
    };
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @param {any} textRedactAnnotations - It describes about the text markup annotations
     * @param {number} pageNumber - It describes about the page number
     * @param {HTMLElement} canvas - It describe the canvas.
     * @param {number} factor - It describe the zoom factor.
     * @param {boolean} isImportAction - It describes about the isImportTextMarkup
     * @param {boolean} isAnnotOrderAction - It describes about the isAnnotOrderAction
     * @private
     * @returns {any} - redaction annotation
     */
    Redaction.prototype.renderTextRedactAnnotations = function (textRedactAnnotations, pageNumber, canvas, factor, isImportAction, isAnnotOrderAction) {
        if (canvas) {
            var context = canvas.getContext('2d');
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.setLineDash([]);
            var annotations_1;
            if (!isImportAction && !isAnnotOrderAction) {
                annotations_1 = this.getAnnotations(pageNumber, textRedactAnnotations);
            }
            else {
                annotations_1 = textRedactAnnotations;
            }
            if (textRedactAnnotations) {
                textRedactAnnotations.forEach(function (textMarkupAnnotation) {
                    var exists = annotations_1.some(function (existingAnnotation) {
                        return existingAnnotation.annotName === textMarkupAnnotation.AnnotName;
                    });
                    if (!exists) {
                        annotations_1.push(textMarkupAnnotation);
                    }
                });
            }
            if (annotations_1) {
                var distinctAnnotations = [];
                for (var i = 0; i < annotations_1.length; i++) {
                    var duplicateFound = false;
                    for (var j = 0; j < distinctAnnotations.length; j++) {
                        if (annotations_1[parseInt(i.toString(), 10)].AnnotName ===
                            distinctAnnotations[parseInt(j.toString(), 10)].AnnotName &&
                            annotations_1[parseInt(i.toString(), 10)].annotName === distinctAnnotations[parseInt(j.toString(), 10)].annotName) {
                            duplicateFound = true;
                            break;
                        }
                    }
                    if (!duplicateFound) {
                        distinctAnnotations.push(annotations_1[parseInt(i.toString(), 10)]);
                    }
                }
                annotations_1 = distinctAnnotations;
            }
            if (annotations_1) {
                for (var i = 0; i < annotations_1.length; i++) {
                    var annotation = annotations_1[parseInt(i.toString(), 10)];
                    if (annotation.annotName === this.hoveredRedactionAnnotName) {
                        if (!this.isRedactionHovered && this.isAnnotationHoverd) {
                            var fillColor = updateColorWithOpacity(annotation.fillColor, 1);
                            annotation.markerFillColor = fillColor;
                            annotation.markerBorderColor = fillColor;
                            annotation.markerOpacity = 1;
                            this.isAnnotationHoverd = false;
                        }
                        else {
                            if (this.orginalFillColor) {
                                var fillColor = updateColorWithOpacity(this.orginalFillColor, annotation.markerOpacity);
                                annotation.markerFillColor = fillColor;
                                annotation.markerBorderColor = this.orginalBorderColor;
                                annotation.markerOpacity = this.orginalOpacity;
                                // Remove overlay text
                                if (annotation.overlayText) {
                                    this.pdfViewer.annotation.redactionOverlayTextModule.removeRedactionOverlayText(annotation);
                                }
                            }
                        }
                    }
                    var annotationObject = null;
                    var isAnnotationRotated = void 0;
                    if (annotation.RedactionType === 'textRedact' || annotation.TextMarkupAnnotationType) {
                        if (isImportAction) {
                            if (this.pdfViewerBase.isJsonImported) {
                                var newArray = [];
                                for (var i_1 = 0; i_1 < annotation.Bounds.length; i_1++) {
                                    annotation.Bounds[parseInt(i_1.toString(), 10)] = this.pdfViewerBase.
                                        importJsonForRotatedDocuments(annotation.Rotate, pageNumber, annotation.Bounds[parseInt(i_1.toString(), 10)], annotation.AnnotationRotation);
                                    annotation.Bounds[parseInt(i_1.toString(), 10)].left = annotation.Bounds[parseInt(i_1.toString(), 10)].X;
                                    annotation.Bounds[parseInt(i_1.toString(), 10)].top = annotation.Bounds[parseInt(i_1.toString(), 10)].Y;
                                    newArray.push(annotation.Bounds[parseInt(i_1.toString(), 10)]);
                                }
                                annotation.Bounds = newArray;
                                isAnnotationRotated = this.pdfViewerBase.isPageRotated;
                            }
                        }
                        annotation.annotationAddMode = this.pdfViewer.annotationModule.
                            findAnnotationMode(annotation, pageNumber, annotation.AnnotType);
                        annotation.allowedInteractions = annotation.AllowedInteractions ? annotation.AllowedInteractions :
                            this.pdfViewer.annotationModule.updateAnnotationAllowedInteractions(annotation);
                        annotation.AnnotationSettings = annotation.AnnotationSettings ? annotation.AnnotationSettings :
                            this.pdfViewer.annotationModule.updateAnnotationSettings(annotation);
                        if (annotation.IsLocked) {
                            annotation.AnnotationSettings.isLock = annotation.IsLocked;
                        }
                        annotationObject = {
                            shapeAnnotationType: 'Redaction', annotationIndex: annotation.AnnotationIndex, annotType: 'TextRedaction', fillColor: annotation.FillColor,
                            allowedInteractions: annotation.allowedInteractions, markerOpacity: annotation.MarkerOpacity,
                            bounds: annotation.Bounds, author: annotation.Author, subject: annotation.Subject,
                            modifiedDate: annotation.ModifiedDate, note: annotation.Note, annotationId: annotation.AnnotName,
                            annotName: annotation.AnnotName, id: annotation.AnnotName, comments: this.pdfViewer.annotationModule.getAnnotationComments(annotation.Comments, annotation, annotation.Author),
                            review: { state: annotation.State, stateModel: annotation.StateModel,
                                modifiedDate: annotation.ModifiedDate, author: annotation.Author }, pageNumber: pageNumber,
                            pageIndex: pageNumber, redactionContent: annotation.TextMarkupContent,
                            annotationSelectorSettings: this.getSettings(annotation),
                            customData: this.pdfViewer.annotation.getCustomData(annotation), annotationAddMode: annotation.annotationAddMode, annotationSettings: annotation.AnnotationSettings,
                            isLocked: annotation.IsLocked, isPrint: annotation.IsPrint, isCommentLock: annotation.IsCommentLock,
                            rotateAngle: annotation.AnnotationRotation,
                            markerBorderColor: annotation.MarkerBorderColor,
                            markerFillColor: annotation.MarkerFillColor,
                            fontFamily: annotation.FontFamily,
                            fontSize: annotation.FontSize,
                            textAlign: annotation.TextAlignment,
                            fontColor: annotation.FontColor,
                            isRepeat: annotation.IsRepeat,
                            overlayText: annotation.OverlayText
                        };
                        if (isNullOrUndefined(annotation.TextMarkupContent) && isNullOrUndefined(annotation.textMarkupContent)) {
                            var markedBounds = annotation.Bounds;
                            var storedData = this.pdfViewerBase.getStoredData(pageNumber, true);
                            if (isNullOrUndefined(storedData)) {
                                this.pdfViewerBase.requestForTextExtraction(pageNumber, annotationObject);
                            }
                            else {
                                var pageCharText = storedData.pageText.split('');
                                var characterBounds = this.pdfViewerBase.textLayer.
                                    characterBound[parseInt(pageNumber.toString(), 10)];
                                var textMarkupContent = this.pdfViewerBase.
                                    textMarkUpContent(markedBounds, pageCharText, characterBounds);
                                annotationObject.redactionContent = textMarkupContent;
                            }
                        }
                        if (annotation.annotName !== this.hoveredRedactionAnnotName) {
                            this.pdfViewer.add(annotationObject);
                            this.pdfViewer.annotationModule.storeAnnotations(pageNumber, annotationObject, '_annotations_redaction');
                        }
                        if (this.isAddAnnotationProgramatically) {
                            var settings = {
                                shapeAnnotationType: annotation.shapeAnnotationType,
                                markerBorderColor: annotation.markerBorderColor,
                                markerFillColor: annotation.markerFillColor,
                                opacity: annotation.markerOpacity,
                                overlayText: annotation.overlayText || '',
                                fontColor: annotation.fontColor,
                                fontSize: annotation.fontSize || 14,
                                fontFamily: annotation.fontFamily,
                                textAlign: annotation.textAlign,
                                author: annotation.author,
                                subject: annotation.subject,
                                modifiedDate: annotation.modifiedDate
                            };
                            this.pdfViewer.fireAnnotationAdd(annotationObject.pageNumber, annotationObject.annotName, 'Redaction', annotationObject.bounds, settings);
                        }
                    }
                    if (annotation.RedactionType !== 'redaction') {
                        annotationObject = annotationObject ? annotationObject : annotation;
                    }
                    this.drawTextRedactAnnotation(annotationObject, factor, pageNumber, context);
                }
            }
        }
    };
    Redaction.prototype.getAddedAnnotation = function (type, color, opacity, bounds, author, subject, predefinedDate, note, isCommentLock, rect, pageNumber, textContent, startIndex, endIndex, isMultiSelect, allowedInteractions, annotationRotate) {
        var modifiedDate = predefinedDate ? predefinedDate : this.pdfViewer.annotation.
            stickyNotesAnnotationModule.getDateAndTime();
        var annotationName = this.pdfViewer.annotation.createGUID();
        var commentsDivid = this.pdfViewer.annotation.stickyNotesAnnotationModule.addComments('textMarkup', pageNumber + 1, type);
        if (commentsDivid) {
            document.getElementById(commentsDivid).id = annotationName;
        }
        var annotationSettings = this.pdfViewer.annotationSettings;
        var isPrint = true;
        var annotation = {
            shapeAnnotationType: type, status: AnnotationStatus.NewlyAdded, fillColor: this.pdfViewer.redactionSettings.fillColor,
            markerOpacity: opacity,
            bounds: bounds, author: author, annotType: 'TextRedaction',
            allowedInteractions: allowedInteractions, subject: subject, modifiedDate: modifiedDate, note: note,
            annotName: annotationName, id: annotationName, comments: [], review: { state: '', stateModel: '', author: author, modifiedDate: modifiedDate },
            pageNumber: pageNumber, pageIndex: pageNumber, redactionContent: textContent, annotationId: annotationName,
            annotationSelectorSettings: this.pdfViewer.redactionSettings.annotationSelectorSettings,
            customData: this.pdfViewer.annotation.getTextMarkupData(subject), annotationAddMode: 'TextRedaction',
            annotationSettings: annotationSettings, isPrint: isPrint, isCommentLock: isCommentLock,
            rotateAngle: annotationRotate.toString(), markerBorderColor: this.pdfViewer.redactionSettings.markerBorderColor,
            markerFillColor: color, fontFamily: this.pdfViewer.redactionSettings.fontFamily,
            fontSize: this.pdfViewer.redactionSettings.fontSize,
            textAlign: this.pdfViewer.redactionSettings.textAlignment,
            fontColor: this.pdfViewer.redactionSettings.fontColor,
            isRepeat: this.pdfViewer.redactionSettings.isRepeat,
            overlayText: this.pdfViewer.redactionSettings.overlayText,
            isLocked: false
        };
        annotation.annotationSettings = this.pdfViewer.annotationModule.updateAnnotationSettings(annotation);
        var isSkip = false;
        // Add the annotation to the viewer
        this.pdfViewer.add(annotation);
        var storedIndex = this.pdfViewer.annotationModule.storeAnnotations(pageNumber, annotation, '_annotations_redaction');
        this.pdfViewer.annotationModule.addAction(pageNumber, storedIndex, annotation, 'Addition', null);
        return annotation;
    };
    Redaction.prototype.getPageContext = function (pageNumber, canvasId) {
        var canvas;
        if (canvasId === '_annotationCanvas_') {
            canvas = this.pdfViewerBase.getAnnotationCanvas(canvasId, pageNumber);
        }
        else {
            canvas = this.pdfViewerBase.getElement(canvasId + pageNumber);
        }
        var context = null;
        if (canvas) {
            context = canvas.getContext('2d');
        }
        return context;
    };
    Redaction.prototype.getMagnifiedValue = function (value, factor) {
        return value * factor;
    };
    Redaction.prototype.drawTextRedactAnnotation = function (newAnnotation, zoomFactor, pageNumber, newcanvas) {
        if (newAnnotation && newAnnotation.bounds && !isNullOrUndefined(newAnnotation.bounds.length)) {
            var newBounds = [];
            var x = 0;
            var y = 0;
            var width = 0;
            var height = 0;
            var currentTop = 0;
            var nextTop = 0;
            var currentLeft = 0;
            var nextLeft = 0;
            var currentRotation = 0;
            var isEqual = false;
            for (var i = 0; i < newAnnotation.bounds.length; i++) {
                var newAnnotationBounds = newAnnotation.bounds[parseInt(i.toString(), 10)];
                currentTop = newAnnotationBounds.top ?
                    newAnnotationBounds.top : newAnnotationBounds.Top;
                nextTop = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ? newAnnotation.bounds[i + 1].top ?
                    newAnnotation.bounds[i + 1].top : newAnnotation.bounds[i + 1].Top : 0;
                currentLeft = newAnnotationBounds.left ?
                    newAnnotationBounds.left : newAnnotationBounds.Left;
                nextLeft = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ? newAnnotation.bounds[i + 1].left ?
                    newAnnotation.bounds[i + 1].left : newAnnotation.bounds[i + 1].Left : 0;
                var pageRotate = this.pdfViewerBase.pageSize[newAnnotation.pageNumber].rotation;
                currentRotation = !isNullOrUndefined(newAnnotationBounds.rotation) ?
                    newAnnotationBounds.rotation : pageRotate ? pageRotate : 0;
                var rotation180Exists = (currentRotation === 0) || (currentRotation === 2) || (currentRotation === 180);
                if (rotation180Exists) {
                    var currentRight = newAnnotationBounds.right ?
                        newAnnotationBounds.right : newAnnotationBounds.Right;
                    var nextRight = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ?
                        newAnnotation.bounds[i + 1].right ? newAnnotation.bounds[i + 1].right : newAnnotation.bounds[i + 1].Right : 0;
                    isEqual = ((nextRight === 0 || Math.abs(currentLeft - nextRight) < 0.5) ||
                        (nextLeft === 0 || Math.abs(currentRight - nextLeft) < 0.5));
                }
                else {
                    var currentBottom = newAnnotationBounds.bottom ? newAnnotationBounds.bottom : newAnnotationBounds.Bottom;
                    var nextBottom = !isNullOrUndefined(newAnnotation.bounds[i + 1]) ? newAnnotation.bounds[i + 1].bottom ?
                        newAnnotation.bounds[i + 1].bottom : newAnnotation.bounds[i + 1].Bottom : 0;
                    isEqual = (nextBottom === 0 || (Math.abs(nextBottom - currentTop) < 0.5) || Math.abs(nextTop - currentBottom) < 0.5);
                }
                if (newAnnotation.bounds.length > 1 && i < newAnnotation.bounds.length - 1 && (currentTop === nextTop ||
                    currentLeft === nextLeft) && isEqual) {
                    newBounds.push(newAnnotationBounds);
                }
                else {
                    if (i === newAnnotation.bounds.length - 1 || newAnnotation.bounds.length >= 1) {
                        newBounds.push(newAnnotationBounds);
                    }
                    if (newBounds.length >= 1) {
                        x = newBounds.reduce(function (min, rect) { return (rect.left ? rect.left : rect.Left || 0) < min ?
                            (rect.left ? rect.left : rect.Left || 0) : min; }, Infinity);
                        y = newBounds.reduce(function (min, rect) { return (rect.top ? rect.top : rect.Top || 0) < min ?
                            (rect.top ? rect.top : rect.Top || 0) : min; }, Infinity);
                        if (!this.pdfViewerBase.clientSideRendering || rotation180Exists) {
                            if (!rotation180Exists) {
                                width = newBounds[0].width ? newBounds[0].width : newBounds[0].Width;
                            }
                            else {
                                height = newBounds[0].height ? newBounds[0].height : newBounds[0].Height;
                            }
                            for (var j = 0; j < newBounds.length; j++) {
                                if (!rotation180Exists) {
                                    height += newBounds[parseInt(j.toString(), 10)].height ?
                                        newBounds[parseInt(j.toString(), 10)].height : newBounds[parseInt(j.toString(), 10)].Height;
                                }
                                else if ((!isNaN(newBounds[parseInt(j.toString(), 10)].width) &&
                                    newBounds[parseInt(j.toString(), 10)].width > 0) ||
                                    (!isNaN(newBounds[parseInt(j.toString(), 10)].Width) &&
                                        newBounds[parseInt(j.toString(), 10)].Width > 0)) {
                                    width += newBounds[parseInt(j.toString(), 10)].width ?
                                        newBounds[parseInt(j.toString(), 10)].width : newBounds[parseInt(j.toString(), 10)].Width;
                                }
                            }
                        }
                        else {
                            width += newBounds[0].width ? newBounds[0].width : newBounds[0].Width;
                            height = newBounds.reduce(function (sum, rect) { return sum + (rect.height ? rect.height : rect.Height || 0); }, 0);
                        }
                        if (width !== 0 && height !== 0) {
                            this.renderTextRedactAnnotation(newcanvas, this.getMagnifiedValue(x - 0.5, zoomFactor), this.getMagnifiedValue(y - 0.5, zoomFactor), this.getMagnifiedValue(width + 0.5, zoomFactor), this.getMagnifiedValue(height + 0.5, zoomFactor), newAnnotation.markerOpacity, newAnnotation.markerFillColor, newAnnotation.markerBorderColor, zoomFactor, pageNumber);
                        }
                        newBounds = [];
                        width = 0;
                        height = 0;
                    }
                }
            }
        }
    };
    Redaction.prototype.renderTextRedactAnnotation = function (context, x, y, width, height, opacity, color, borderColor, zoomFactor, pageIndex) {
        var ratio;
        if (context.canvas.id === this.pdfViewer.element.id + '_print_annotation_layer_' + pageIndex) {
            ratio = this.pdfViewerBase.getZoomRatio(zoomFactor);
        }
        else {
            ratio = this.pdfViewerBase.getZoomRatio();
        }
        if (context) {
            context.beginPath();
            context.rect(x * ratio, y * ratio, width * ratio, height * ratio);
            context.closePath();
            context.globalAlpha = opacity;
            context.fillStyle = color;
            context.strokeStyle = borderColor;
            context.lineWidth = 1;
            context.msFillRule = 'nonzero';
            context.fill();
            context.stroke();
            context.save();
        }
    };
    /**
     * Draws a text redaction annotation on the specified page.
     * This method handles the visual representation of text redactions, typically used to obscure sensitive information.
     * It processes the annotation bounds, calculates positioning based on zoom factors, and manages rendering logic.
     *
     * @param {string} type - The annotation type (e.g., 'Redaction')
     * @param {IRectangle[]} bounds - The bounding rectangles defining the redaction area(s) on the page
     * @param {number} pageNumber - The page number where the redaction should be applied
     * @param {any} rect - Deprecated/unused parameter retained for backward compatibility
     * @param {number} factor - The current zoom factor for magnifying annotation dimensions
     * @param {string} textContent - The sensitive text content being redacted
     * @param {number} startIndex - The starting character index of the redacted text in the document
     * @param {number} endIndex - The ending character index of the redacted text in the document
     * @param {boolean} [isMultiSelect] - Indicates whether multiple text selections are being redacted
     * @param {HTMLElement} [targetElement] - The DOM element associated with the redaction (e.g., text layer)
     * @private
     *
     * @returns {void}
     */
    Redaction.prototype.drawTextRedact = function (type, bounds, pageNumber, rect, factor, textContent, startIndex, endIndex, isMultiSelect, targetElement) {
        var annotation = null;
        var author = 'Guest';
        var subject;
        var context = this.getPageContext(pageNumber, '_annotationCanvas_');
        var modifiedDate = this.pdfViewer.annotation.stickyNotesAnnotationModule.getDateAndTime();
        var allowedInteractions;
        var pageDetails = this.pdfViewerBase.pageSize[parseInt(pageNumber.toString(), 10)];
        var annotationRotate = 0;
        var pageRotation = this.pdfViewerBase.getAngle(pageDetails.rotation);
        if (isNullOrUndefined(context)) {
            var pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageNumber);
            if (pageDiv && pageDetails && pageDetails.width && pageDetails.height) {
                // If the 'blendAnnotationsIntoCanvas' is not implemented, it should be created to highlight annotations.
                var canvas = this.pdfViewer.annotationModule.createBlendAnnotationsIntoCanvas(pageDiv, pageDetails.width, pageDetails.height, pageNumber);
                context = canvas.getContext('2d');
            }
        }
        if (context) {
            context.setLineDash([]);
            subject = (this.pdfViewer.highlightSettings.subject !== '' && this.pdfViewer.highlightSettings.subject) ? this.pdfViewer.highlightSettings.subject : this.pdfViewer.annotationSettings.subject ? this.pdfViewer.annotationSettings.subject : 'Highlight';
            author = (this.pdfViewer.highlightSettings.author !== 'Guest' && this.pdfViewer.highlightSettings.author) ? this.pdfViewer.highlightSettings.author : this.pdfViewer.annotationSettings.author ? this.pdfViewer.annotationSettings.author : 'Guest';
            allowedInteractions = this.pdfViewer.highlightSettings.allowedInteractions ? this.pdfViewer.highlightSettings.allowedInteractions : ['None'];
            var opacity = this.pdfViewer.redactionSettings.markerOpacity ? (this.pdfViewer.redactionSettings.markerOpacity > 1 ?
                (this.pdfViewer.redactionSettings.markerOpacity / 100) : this.pdfViewer.redactionSettings.markerOpacity) : 1;
            annotation = this.getAddedAnnotation(type, this.pdfViewer.redactionSettings.markerFillColor, opacity, bounds, author, subject, modifiedDate, '', false, rect, pageNumber, textContent, startIndex, endIndex, isMultiSelect, allowedInteractions, annotationRotate);
            if (annotation) {
                this.drawTextRedactAnnotation(annotation, factor, pageNumber, context);
            }
            if (annotation) {
                this.pdfViewerBase.updateDocumentEditedProperty(true);
                var settings = {
                    shapeAnnotationType: annotation.shapeAnnotationType,
                    markerBorderColor: annotation.markerBorderColor,
                    markerFillColor: annotation.markerFillColor,
                    opacity: annotation.markerOpacity,
                    overlayText: annotation.overlayText || '',
                    fontColor: annotation.fontColor,
                    fontSize: annotation.fontSize || 14,
                    fontFamily: annotation.fontFamily,
                    textAlign: annotation.textAlign,
                    author: annotation.author,
                    subject: annotation.subject,
                    modifiedDate: annotation.modifiedDate
                };
                this.pdfViewer.fireAnnotationAdd(pageNumber, annotation.annotName, 'Redaction', annotation.bounds, settings, textContent, startIndex, endIndex);
            }
        }
    };
    Redaction.prototype.getRgbCode = function (colorString) {
        // eslint-disable-next-line
        if (!colorString.match(/#([a-z0-9]+)/gi) && !colorString.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)) {
            colorString = this.pdfViewer.annotationModule.nameToHash(colorString);
        }
        var stringArray = colorString.split(',');
        if (isNullOrUndefined(stringArray[1])) {
            colorString = this.pdfViewer.annotationModule.getValue(colorString, 'rgba');
            stringArray = colorString.split(',');
        }
        var r = parseInt(stringArray[0].split('(')[1], 10);
        var g = parseInt(stringArray[1], 10);
        var b = parseInt(stringArray[2], 10);
        var a = parseFloat(stringArray[3]);
        return { r: r, g: g, b: b, a: a };
    };
    /**
     * Retrieves the collection of redaction annotations for a given page.
     * If stored annotations exist for the page, they are returned; otherwise,
     * the provided redactionAnnotations array is used. This handles both stored
     * annotations (from session/local storage) and programmatically provided ones.
     *
     * @param {number} pageIndex - The page index to retrieve annotations for
     * @param {any[] | null} redactionAnnotations - Optional default annotations to use if no stored annotations exist
     * @private
     *
     * @returns {any[]} The array of redaction annotations for the specified page
     */
    Redaction.prototype.getAnnotations = function (pageIndex, redactionAnnotations) {
        var annotationCollection = [];
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_redaction');
        if (storeObject) {
            var annotObject = JSON.parse(JSON.stringify(storeObject));
            var index = this.pdfViewer.annotationModule.getPageCollection(annotObject, pageIndex);
            if (index != null && annotObject[parseInt(index.toString(), 10)]) {
                annotationCollection = annotObject[parseInt(index.toString(), 10)].annotations;
            }
            else {
                annotationCollection = redactionAnnotations;
            }
        }
        else {
            annotationCollection = redactionAnnotations;
        }
        return annotationCollection;
    };
    /**
     * Validates and normalizes min/max width and height constraints for Redaction settings.
     * @private
     * @param {RedactionSettingsModel} settings - represents the redactionSeettings
     * @returns {void}
     */
    Redaction.prototype.validateRedactionSettings = function (settings) {
        var redaction = !isNullOrUndefined(settings) ?
            settings : this.pdfViewer.redactionSettings;
        if (redaction && (redaction.minHeight || redaction.minWidth || redaction.maxHeight || redaction.maxWidth)) {
            this.pdfViewerBase.normalizeMinMaxPair(redaction, 'minWidth', 'maxWidth');
            this.pdfViewerBase.normalizeMinMaxPair(redaction, 'minHeight', 'maxHeight');
        }
    };
    return Redaction;
}());
export { Redaction };
